module.exports = __webpack_public_path__ + "static/media/pospay-logo.f46022a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layout/metronic/pospay-logo.svg
// module id = 364
// module chunks = 2